<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs />
        <div class="table-agile-info">
          <div class="management-header">
            <el-select v-model="countryId" placeholder="请选择" @change="chooseCountry">
              <el-option
                v-for="item in countryList"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
            渠道来源
            <jm-channel
              v-model="channel"
              :is-all="true"
              :final.sync="channelFinal"
              clearable
              ref="channelRef"
              filterable />
            <span>&nbsp; &nbsp;</span>
            <el-button type="primary" size="medium" @click="chooseCountry(countryId)" :disabled="loading">搜索</el-button>
            <el-button v-permission="[1]" type="success" size="medium" @click="downloadExcel" :disabled="loading">导出数据</el-button>
          </div>
          <div class="serch-wapper" v-loading="loading">
            <div class="water-table">
              <div :class="isFixed?'water-head-fix water-head':'water-head'">
                <el-col class="water-name-common" :span="4">老师</el-col>
                <el-col
                  class="water-name"
                  :span="2"
                  v-for="(item,index) in tableHeader"
                  :key="index"
                >
                  <el-tooltip :content="item.intro" effect="light">
                    <span>
                      {{ item.name }} <i class="el-icon-question" />
                    </span>
                  </el-tooltip>
                  <div>
                    {{ '剩余' + item.value }}
                  </div>
                </el-col>
                <el-col class="water-name-common" :span="4">操作</el-col>
              </div>
              <div class="water-content-list">
                <el-form status-icon ref="waterForm">
                  <el-col
                    class="water-tr"
                    :span="24"
                    v-for="(item,index) in tableData"
                    :key="index"
                  >
                    <el-col :span="4" class="water-td">
                      {{ item.name }}
                      <br />
                      <span class="water-all" title="总资源数">{{ item.total }}</span>
                      (
                      <span class="water-mix" style="color:green" title="公海资源数">{{ item.studentNum }}</span> +
                      <span class="water-mix" style="color:red" title="一手资源数">{{ item.total - item.studentNum }}</span>
                      )
                    </el-col>
                    <!--循环遍历输入值：开始-->
                    <el-col :span="2" class="water-td" v-for="header in tableHeader" :key="header.key">
                      <el-form-item>
                        <el-input
                          min="0"
                          max="9999"
                          type="number"
                          v-model.number="item.userData[header.key]"
                          autocomplete="off"
                          placeholder="0"
                          :disabled="!header.value" />
                      </el-form-item>
                    </el-col>
                    <!--循环遍历输入值：结束-->
                    <el-col :span="4">
                      <div class="btn-group">
                        <el-button type="primary" size="mini" @click="screen(index)">分配</el-button>
                        <el-button type="warning" size="mini" @click="clearInput(index)">清空</el-button>
                      </div>
                    </el-col>
                  </el-col>
                </el-form>
              </div>
            </div>
          </div>
          <div class="btn-group">
            <el-button type="primary" @click="manageData" :disabled="loading">全部分配</el-button>
            <el-button type="warning" @click="clearAllInput" :disabled="loading">清空输入</el-button>
            <el-button type="info" :disabled="loading">
              <router-link
                :to="{ name: 'internationalWatersManageHistory',query: {countryId: countryId} }"
                target="_blank"
              >分配记录</router-link>
            </el-button>
            <el-button type="success" :disabled="loading">
              <router-link :to="{ name: 'giveUp' }" target="_blank">记录导出</router-link>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jmDictSelect, jmChannel } from '@/components/tool';
import lockr from 'lockr';
import _ from 'lodash';

export default {
  data() {
    return {
      reManage: 0,
      countryId: null,
      tableHeader: null,
      tableData: [],
      countryList: [],
      defaultUserData: {},
      isFixed: null,
      loading: true,
      localData: null,
      channelFinal: false,
      channelRef: false,
      channel: {},
    };
  },
  components: {
    jmDictSelect,
    jmChannel
  },
  methods: {
    /**
     * 判断是否是再次分配
     */
    decideReManage() {
      this.reManage = this.$route.query.reManage;
      let countryId = Number(this.$route.query.countryId);
      this.localData = lockr.get('reManage');
      if (this.reManage) {
        this.chooseCountry(countryId);
      } else {
        this.chooseCountry(this.countryId);
      }
    },
    /**
     * 按人清空
     */
    clearInput(index) {
      let levelData = this.tableData[index];

      levelData.userData = {
        crmsayer: levelData.userData.crmsayer,
        ...this.defaultUserData
      };
    },
    clearAllInput() {
      this.tableData.forEach((item, index) => {
        this.clearInput(index);
      });
    },
    /**
     * 获取国家列表
     */
    getCountryList() {
      this.$http
        ._post({ url: '/index/international_waters/getCountryList' })
        .then(({ data }) => {
          this.countryList = data;
          this.countryId = data[0].id;
          this.decideReManage();
        });
    },
    /**
     * 选择国家
     */
    chooseCountry(val) {
      this.countryId = val;
      this.upData(val);
    },
    /**
     * 更新数据
     */
    upData(id) {
      this.loading = true;
      Promise.all([
        this.$http._post({
          url: '/index/international_waters/getSayerList',
          data: { countryId: id }
        }),
        this.$http._post({
          url: '/index/international_waters/getResourceLevelNumber',
          data: { countryId: id, channel: this.channel }
        })
      ]).then(([{ data: sayerData }, { data: levelNumber }]) => {
        this.initResourceLevelData(levelNumber);
        this.searchSayerList(sayerData);
      });
    },
    /**
     * 根据国家查询顾问列表
     */
    searchSayerList(data) {
      let sayerList = Object.values(data);
      sayerList.forEach((item) => {
        item.userData = {
          crmsayer: item.userid,
          ...this.defaultUserData
        };
      });
      this.tableData = sayerList;

      // 再次配置
      if (this.reManage) {
        this.tableData.forEach((item) => {
          this.localData.forEach((itemLocal) => {
            if (item.userData.crmsayer === itemLocal.crmsayer) {
              item.userData = itemLocal;
            }
          });
        });
      }
      this.loading = false;
    },
    /**
     * 查询指定国家公海各个资源级别的数量
     */
    initResourceLevelData (data) {
      this.tableHeader = data.filter((item) => {
        if (this.countryId === 485) { // 前程日本
          return item.key !== 'levelN41';
        }
        return item.key !== 'levelN42';
      });

      this.tableHeader.forEach((item) => {
        this.defaultUserData[item.key] = null;
      });
      this.loading = false;
    },
    /**
     * 分配
     */
    screen(index) {
      let that = this;
      this.$confirm('确认分配后，将无法撤回，是否确认？', '确认分配', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ajaxData = [that.tableData[index].userData];
          // 请求
          this.assignmentAjax(ajaxData)
            .then(() => {
              this.$message({
                type: 'success',
                message: '分配成功!'
              });
              this.clearInput(index);
            })
            .catch((res) => {
              this.$message({
                type: 'error',
                message: res
              });
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消分配'
          });
        });
    },
    /**
     * 分配资源请求
     */
    async assignmentAjax(assignmentData) {
      // 检查是否超出可分配数量
      let errorMsg = this.checkAssignmentData(assignmentData);
      if (errorMsg) {
        return Promise.reject(new Error(errorMsg));
      }

      let ajaxData = {
        countryId: this.countryId,
        configData: assignmentData,
        channel: this.channel,
      };

      return new Promise((resolve, reject) => {
        this.$http
          ._post({
            url: '/index/international_waters/distributionSource',
            data: ajaxData
          })
          .then((res) => {
            // console.log(res);
            this.upData(this.countryId);
            lockr.rm('reManage');
            return resolve(res);
          })
          .catch((res) => {
            return reject(res);
          });
      });
    },
    /**
     * 检查用户分配的正行数据是否有效
     */
    isVaildRow(userDataRow) {
      let userDataKey = _.keys(this.defaultUserData);
      let checkNums = _.pick(userDataRow, userDataKey);
      // 取出都为真的值（'0' 已转为 0）
      let checkVaild = _.compact(_.map(checkNums, _.parseInt));
      return checkVaild.length > 0;
    },
    /**
     * 全部分配
     */
    manageData() {
      let that = this;
      this.$confirm(
        '确认后，对填写分配数的所有顾问进行公海资源分配，无法撤回，是否确认？',
        '确认全部分配',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          let tableList = [];

          // 过滤输入值
          that.tableData.forEach((item) => {
            if (this.isVaildRow(item.userData)) {
              tableList.push(item.userData);
            }
          });

          this.assignmentAjax(tableList)
            .then(() => {
              this.$message({
                type: 'success',
                message: '分配成功!'
              });
              this.clearAllInput();
            })
            .catch((res) => {
              this.$message({
                type: 'error',
                message: res
              });
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消分配'
          });
        });
    },
    downloadExcel() {
      this.exporting = true;
      this.$http._post({
        url: '/index/international_waters/downloadExcel',
        data: { countryId: this.countryId, channel: this.channel },
      }).then(({ data }) => {
        this.exporting = false;
        this.$http._download({
          filename: data,
          download: '资源可分配列表.xlsx'
        });
      }).catch((data) => {
        if (typeof data.data !== 'undefined' && data.data.result === -1) {
          this.$message.error(data.data.data);
        } else {
          this.$message.error('服务异常');
        }
        this.exporting = false;
      });
    },
    // 验证
    checkAssignmentData(assignmentData) {
      console.info(' >>> 待分配数据');
      console.table(assignmentData);

      // 检查是否超出可分配数量
      let error = [];
      let total = 0;
      this.tableHeader.forEach((header) => {
        let levelNum = _.sumBy(assignmentData, header.key);
        if (levelNum > header.value) {
          error.push(`${header.name}不足，无法分配`);
        }
        total += levelNum;
        // 调试有效值
        console.info(header.key, ' (MAX=', header.value, '): ', levelNum);
      });

      if (!total) {
        return '没有设置数量，无法分配';
      }
      if (error.length > 0) {
        return error[0];
      }
      return false;
    },
  },
  created() {
    this.getCountryList();
  },
  watch: {
    /**
     * 监听分配表单
     */
  },
  computed: {
  }
};
</script>
<style scoped>
.management-header, .all-num {
  margin-top: 6px;
  margin-bottom: 6px;
}
.management-header a {
  margin-left: 10px;
  color: #169bd5;
}
.serch-wapper::after, .country::after {
  display: block;
  content: '';
  clear: both;
  opacity: 0;
}
.btn-group {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
</style>
<style lang="less" scoped>
.water-table {
  width: 100%;
  height: auto;
  margin-bottom: 20px;
  margin-top: 20px;
  .water-head-fix {
    position: fixed;
    top: 80px;
    // padding: 10px 20px;
    box-shadow: 5px 5px 5px #ccc;
    width: 100%;
    z-index: 99;
  }
  .water-head {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #01142d;

    .water-name-common {
      border-right: 1px solid #fff;
      color: #fff;
      font-size: 14px;
      text-align: center;
    }
    .water-name {
      border-right: 1px solid #fff;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
    }
  }
  .water-content-list {
    width: 100%;
    height: 50px;
    .water-tr {
      width: 100%;
      height: 100%;
      border: 1px solid #ccc;
      border-top: 0px;
      border-right: 0px;
      .water-td {
        height: 100%;
        border-right: 1px solid #ccc;
        text-align: center;
        line-height: 25px;
        .water-all {
          color: #333;
        }
      }
      .btn-group {
        width: 100%;
        height: 100%;
        margin-top: 10px;
      }
    }
  }
}
</style>
<style lang="less">
.water-content-list {
  .el-input__inner {
    text-align: center;
    width: 100%;
    height: 48px;
    line-height: 50px;
    border-color: #fff;
    color: #333;
    font-weight: bold;
    font-size: 14px;
    padding: 0;
  }
  .el-input__inner::-webkit-input-placeholder {
    font-weight: normal;
    color: #ddd !important;
  }
  .el-form-item{
    margin-bottom: 0;height:100%
  }
  .el-form-item.is-error .el-input__inner {
    border-color: #f56c6c;
  }
  .el-input__inner:focus {
    border-color: #fff;
  }
}
</style>
